export const typographyTheme = {
  typography: {
    fontFamily: [
      "Noto Sans JP",
      "system-ui",
      "Arial",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      '"Helvetica Neue"',
      "sans-serif",
    ].join(","),
    htmlFontSize: 16,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    h1: {
      fontSize: "4rem",
      lineHeight: 1.125,
      fontWeight: 700,
    },
    h2: {
      fontSize: "2.625rem",
      lineHeight: 1.07811657721,
      fontWeight: 700,
    },
    h3: {
      fontSize: "2rem",
      lineHeight: 1.125,
      fontWeight: 700,
    },
    h4: {
      fontSize: "1.563rem",
      lineHeight: 1.09375,
      fontWeight: 700,
    },
    h5: {
      fontSize: "1.313rem",
      lineHeight: 1.31252050813,
      fontWeight: 700,
    },
    h6: {
      fontSize: "1.125rem",
      lineHeight: 1.3160780873,
      fontWeight: 700,
    },
    body1: {
      fontWeight: 500,
    },
    button: {
      fontWeight: 700,
    },
  },
};
